import type { StatusChipProps } from '@/components/chip/ChipTicketStatus';
import ChipTicketStatus from '@/components/chip/ChipTicketStatus';
import { StatusTicketEnum } from '@/types/enums/status-ticket.enum';

export const getTicketStatusData = (props: StatusChipProps) => {
    return ChipTicketStatus(props);
};

export const getTicketOptionsFilter = () => {
    const enumValues = StatusTicketEnum;

    const options: any[] = [];

    Object.keys(enumValues).forEach(key => {
        const data = getTicketStatusData({
            status: enumValues[key],
            showChip: false,
        });

        if (key !== 'DEFAULT') {
            options.push({
                id: enumValues[key],
                value: enumValues[key].toUpperCase(),
                title: data.label,
                label: data.label,
            });
        }
    });

    return options;
};
